/*! @azure/msal-common v13.3.3 2024-06-06 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "13.3.3";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
